module.exports = __webpack_public_path__ + "img/jj1.535d8049.jpg";